// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__ewjMO","container":"styles_container__1pETP"};